import React from 'react';
import LandingPageCTABanner from 'shared/components/LandingPageCTA/LandingPageCTABanner';

const RegistrationBanner = ({
  text = '',
  buttons = [],
  countDownTimer,
  secondaryComponent,
}) => (
  <LandingPageCTABanner
    text={text}
    buttons={buttons}
    secondaryComponent={secondaryComponent}
    countDownTimer={countDownTimer}
  />
);

export default RegistrationBanner;
